import { render, staticRenderFns } from "./FaqConflictedButtonAction.vue?vue&type=template&id=4e8fd006&scoped=true&"
import script from "./FaqConflictedButtonAction.vue?vue&type=script&lang=js&"
export * from "./FaqConflictedButtonAction.vue?vue&type=script&lang=js&"
import style0 from "./FaqConflictedButtonAction.vue?vue&type=style&index=0&id=4e8fd006&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8fd006",
  null
  
)

export default component.exports